import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    title: {
        color: theme.palette.tailwind.slate[900],
    },
    cardsWrap: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "1.25rem",
    },
}))

type HelpSectionProps = Readonly<
    PropsWithChildren<{
        title: string
    }>
>

export const HelpSection = ({ title, children }: HelpSectionProps) => {
    const { classes } = useStyles()

    return (
        <Stack gap="1.25rem">
            <Typography variant="h5" className={classes.title}>
                {title}
            </Typography>
            <Box className={classes.cardsWrap}>{children}</Box>
        </Stack>
    )
}
